import React from "react";
import ReactDOM from "react-dom/client";

// Libraries
import { BrowserRouter } from "react-router-dom";
import { ParallaxProvider } from "react-scroll-parallax";
import { LazyMotion, domMax } from "framer-motion";

// css
import "./Assets/css/icons.css";
import "./Assets/css/global.css";
import "./Assets/css/pages.css";
import "./index.scss";
import Routeur from "./Routes/Routeur";
import './i18n'; // Importer la configuration i18n

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LazyMotion features={domMax}>
    <ParallaxProvider>
      <BrowserRouter>
        <Routeur />
      </BrowserRouter>
    </ParallaxProvider>
  </LazyMotion>
);
